import React, { useEffect, useState, useRef } from "react";
import { BellOutlined, GlobalOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { useNavigate } from "react-router-dom";

function LoggedInTeacher({ setLoggedIn }) {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [userName, setUserName] = useState("User");
  const [userPhoto, setUserPhoto] = useState(null);
  const [userInitials, setUserInitials] = useState("U");
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
   
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const photo = localStorage.getItem("userPhoto");
    
    if (userInfo.name) {
      setUserName(userInfo.name);
      
      const names = userInfo.name.split(' ');
      let initials = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      setUserInitials(initials);
    } else if (userInfo.email) {
  
      const emailName = userInfo.email.split('@')[0];
      setUserName(emailName);
      setUserInitials(emailName.substring(0, 1).toUpperCase());
    }
    
    if (photo) {
      setUserPhoto(photo);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
     
        const avatarButton = document.querySelector('.user-info-container');
        if (!avatarButton.contains(event.target)) {
          setUserMenuOpen(false);
        }
      }
    };

    if (userMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userMenuOpen]);

  const toggleUserMenu = (e) => {
    e.stopPropagation();
    setUserMenuOpen(!userMenuOpen);
  };

  const handleStudentClick = () => navigate("/courses");
  const handleViewProfileClick = () => navigate("/user-profile");
  const handleCreateClass = () => navigate("/teacher-home");


  const handleSignOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userPhoto");
    setLoggedIn(false);
    navigate("/");
  };

  const userOptions = [
    { label: 'My Classes', route: '/user-classes' },
    { label: 'Classes', route: '/courses' },
    { label: 'Account Settings', route: '/account-settings' },
    { label: 'Refer A Friend', route: null },
    { label: 'Help', route: '/faq' },
    { label: 'Sign Out', route: null, onClick: handleSignOut },
  ];

  return (
    <div className="user-container">
      <span className="teacher-explore-categories" onClick={handleStudentClick}>
        Student
      </span>
      <GlobalOutlined className="teacher-icon" />
      <BellOutlined className="teacher-icon" />

      <div className="user-info-container" onClick={toggleUserMenu}>
        {userPhoto ? (
          <Avatar 
            src={userPhoto} 
            size={32}
          />
        ) : (
          <Avatar 
            size={32}
            style={{ backgroundColor: '#043f2d' }}
          >
            {userInitials}
          </Avatar>
        )}
      </div>

      {userMenuOpen && (
        <div className="user-dropdown-menu" ref={menuRef}>
          <div className="user-info">
            {userPhoto ? (
              <Avatar 
                src={userPhoto} 
                size={64}
                className="user-avatar-large"
              />
            ) : (
              <Avatar 
                size={64}
                className="user-avatar-large"
                style={{ backgroundColor: '#043f2d' }}
              >
                {userInitials}
              </Avatar>
            )}
            <span className="user-name">{userName}</span>
            <span className="create-user" onClick={handleViewProfileClick}>
              View Profile
            </span>
          </div>

          <div className="user-options-title-teach">
            <span className="user-options-text">Teach</span>
            <span className="user-menu-item" onClick={handleCreateClass}>Create Your Class</span>
          </div>
          
          <div className="user-options-title-learn">
            <span className="user-options-text">Learn</span>
          </div>

          {userOptions.map((option, index) => (
            <div
              key={index}
              className="user-menu-item"
              onClick={() => {
                if (option.route) {
                  navigate(option.route);
                } else if (option.onClick) {
                  option.onClick();
                } else {
                  console.log(`${option.label} clicked`);
                }
                setUserMenuOpen(false);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LoggedInTeacher;